function formatDate(date = new Date()) {
    let dateFormat = [
            ("0000" + date.getFullYear()).slice(-4),
            ("00" + (date.getMonth()+1)).slice(-2),
            ("00" + date.getDate()).slice(-2),
        ].join('-')+' '+
        [
            ("00" + date.getHours()).slice(-2),
            ("00" + date.getMinutes()).slice(-2),
            ("00" + date.getSeconds()).slice(-2)
        ].join(':');
    return dateFormat;
}

function getJsonKeys( json ){
            
    let keys = {};
    for (const key in json) {
        keys = {
            ...keys,
            [key]:key
        }
    }

    return keys;
}

function isObjectEqual(one, two){
    return JSON.stringify(one) === JSON.stringify(two);
}

export {
    formatDate,
    getJsonKeys,
    isObjectEqual
}